import React, { useState } from 'react'

import { Button } from 'core-components/library/button'

import { MY_CONNECT_LINE } from '../helpers/DialerSettings'

import { NoConnectLineWarning } from './NoConnectLineWarning'

import styles from './NoConnectLineModalContent.module.scss'

interface IProps {
  onSaveAndCall: (line: MY_CONNECT_LINE) => Promise<void>
  onClose: () => void
}

export const NoConnectLineModalContent = ({ onSaveAndCall, onClose }: IProps) => {
  const [line, setLine] = useState<MY_CONNECT_LINE>(MY_CONNECT_LINE.france)

  return (
    <div className={styles.container}>
      <NoConnectLineWarning line={line} onChangeLine={setLine} />

      <div className={styles.buttonsContainer}>
        <Button
          className={styles.saveAndCallButton}
          disabled={!(line && Object.values(MY_CONNECT_LINE).includes(line))}
          onClick={() => {
            onSaveAndCall(line)
            onClose()
          }}
        >
          Save and Call
        </Button>
        <div className={styles.cancelButtonWrapper}>
          <Button color={'grey'} onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  )
}
